import { render } from "./Product_add.vue?vue&type=template&id=0d82dace&scoped=true"
import script from "./Product_add.vue?vue&type=script&lang=js"
export * from "./Product_add.vue?vue&type=script&lang=js"

import "./Product_add.vue?vue&type=style&index=0&id=0d82dace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d82dace"]])

export default __exports__